// extracted by mini-css-extract-plugin
module.exports = {"rightPanel":"style_rightPanel__1X_9t","generateButton":"style_generateButton__2-Q7B","insightsText":"style_insightsText__1n2Vu"};